import React from 'react';
import {
  makeStyles, mergeClasses, shorthands, tokens,
} from '@fluentui/react-components';
import { DismissCircle20Regular } from '@fluentui/react-icons';

const useErrorMessageBarStyle = makeStyles({
  errorMessageBar: {
    display: 'flex',
    backgroundColor: '#fde7e9',
    ...shorthands.padding(tokens.spacingVerticalS, tokens.spacingHorizontalM),
    ...shorthands.borderRadius(tokens.borderRadiusMedium),
  },
  icon: {
    flexShrink: 0,
  },
  errorText: {
    marginLeft: tokens.spacingHorizontalS,
    fontSize: tokens.fontSizeBase200,
    color: tokens.colorNeutralForeground1,
  },
});

export interface IErrorMessageBarProps {
  className?: string;
  children?: React.ReactNode;
}

export const ErrorMessageBar: React.FC<IErrorMessageBarProps> = React.memo(({
  className,
  children,
}) => {
  const styles = useErrorMessageBarStyle();

  return (
    <div className={mergeClasses(className, styles.errorMessageBar, 'error-message-bar')}>
      <DismissCircle20Regular className={styles.icon} primaryFill="#a80000" />
      <div className={mergeClasses(styles.errorText, 'error-text')}>
        {children}
      </div>
    </div>
  );
});

ErrorMessageBar.defaultProps = {
  className: '',
};
